import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver/FileSaver';

@Injectable()
export class FileSaver {
  saveBlob(fileName: string, file: Blob): void {
    saveAs(file, fileName);
  }
}
